// ===================================
// UPDATED MAIN APP COMPONENT WITH PUBLIC CHAT - src/App.tsx
// ===================================
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// Public Pages
import "./App.css";
import PublicChatWidget from "./components/PublicChatWidget";

// Public routes that don't require authentication
const PublicRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <>{children}</>;
};

const AppContent: React.FC = () => {
  // Check if we're in embedded mode (iframe)
  const isEmbedded = React.useMemo(() => {
    try {
      return (
        window.self !== window.top ||
        new URLSearchParams(window.location.search).has("embed")
      );
    } catch (e) {
      return true; // If we can't access parent, we're probably in iframe
    }
  }, []);

  // If we're embedded, render the widget directly without routing
  if (isEmbedded) {
    return (
      <div className="App h-screen bg-transparent">
        <PublicChatWidget isEmbedded={true} />
      </div>
    );
  }

  // Regular routing for standalone mode
  return (
    <Router>
      <div className="App min-h-screen bg-gray-50">
        <Routes>
          {/* Default Routes */}
          <Route
            path="/"
            element={
              <PublicRoute>
                <PublicChatWidget isEmbedded={false} />
              </PublicRoute>
            }
          />
          <Route
            path="*"
            element={
              <PublicRoute>
                <PublicChatWidget isEmbedded={false} />
              </PublicRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
};

function App() {
  return <AppContent />;
}

export default App;
